module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "Inhalt"
    }
  }, [_vm._v("Inhalt")])]), _vm._v(" "), _c('table', {
    staticClass: "toc",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre8"
  }, [_c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "s6"
  }), _vm._v(" "), _c('td', {
    staticClass: "s6"
  }, [_c('div', {
    staticClass: "center"
  }, [_vm._v("Seite")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Der heilige Aloysius")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#Der_heilige_Aloysius"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Die Alt-Pfarrköchin")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#Die_Alt-Pfarrkoechin"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("D’ Gertrude")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0005#DGertrude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Ein verdienstliches Werk")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#Ein_verdienstliches_Werk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Die Lenebas")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#Die_Lenebas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Die ehr- und tugendsame Jungfrau Euphrosyne")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#Die_ehr-_und_tugendsame_Jungfrau_Euphrosyne",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Das Gespenst")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#Das_Gespenst",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "vat"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Die Leich’")])]), _vm._v(" "), _c('td', {
    staticClass: "vab"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Die_Leich",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0